import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';

export interface AuthorCommentDialogData {
  authorComment: string;
}

export interface AuthorCommentDialogResult {
  authorComment: string;
}

@Component({
  selector: 'app-author-comment-dialog',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule
  ],
  templateUrl: './author-comment-dialog.component.html',
  styleUrl: './author-comment-dialog.component.less'
})
export class AuthorCommentDialogComponent {
  form: FormGroup;

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<AuthorCommentDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AuthorCommentDialogData
  ) {
    this.form = this.fb.group({
      authorComment: [data.authorComment || '', [Validators.maxLength(1000)]]
    });
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onSubmit(): void {
    if (this.form.valid) {
      const result: AuthorCommentDialogResult = {
        authorComment: this.form.get('authorComment')?.value || ''
      };
      this.dialogRef.close(result);
    }
  }
}
